<template>
	<el-container class="friend-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="friend-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="添加好友"
					@click="onShowAddFriend()"></el-button>
				<el-button plain class="add-btn" icon="el-icon-collection-tag" title="好友分组"
					@click="onOpenCreateGroupDialog()"></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<div class="group-bar">
				<el-scrollbar class="group-scroll" wrap-class="group-scroll-wrap">
					<div class="group-items">
						<div class="group-item" :class="{ active: activeGroupId === null }" @click="activeGroupId = null">
							全部
						</div>
						<div v-for="g in friendGroups" :key="g.id" class="group-item"
							:class="{ active: activeGroupId === g.id }" @click="activeGroupId = g.id"
							@dblclick.stop="onOpenEditGroupDialog(g)"
							@mousedown="onGroupMouseDown(g)" @mouseup="onGroupMouseUp" @mouseleave="onGroupMouseUp">
							{{ g.name }}
						</div>
					</div>
				</el-scrollbar>
			</div>
			<el-scrollbar class="friend-items">
				<div v-for="(friends, i) in friendValues" :key="i">
					<div class="letter">{{ friendKeys[i] }}</div>
					<div v-for="(friend) in friends" :key="friend.id">
						<friend-item :friend="friend" :active="friend.id === activeFriend.id"
							@chat="onSendMessage(friend)" @delete="onDelFriend(friend)"
							@click.native="onActiveItem(friend)">
						</friend-item>
					</div>
					<div v-if="i < friendValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container class="container">
			<div class="header" v-show="userInfo.id">
				{{ friendPanelTitle }}
			</div>
			<div v-show="userInfo.id">
				<div class="friend-info">
					<head-image :size="160" :name="friendPanelTitle" :url="userInfo.headImage" radius="10%"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ userInfo.userName }}
								</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}
								</el-descriptions-item>
								<el-descriptions-item label="备注" v-if="isFriend">{{ activeFriend.remark || '—' }}
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex == 0 ? "男" : "女"
								}}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(activeFriend)">发消息</el-button>
							<el-button v-show="isFriend" plain @click="onOpenRemarkDialog">备注</el-button>
							<el-button v-show="isUserTypeOne && isFriend" plain @click="onOpenAssignGroupDialog">分组</el-button>
							<el-button v-show="isUserTypeOne && isFriend && !activeFriend.msgMuted" type="warning" plain
								@click="onToggleMsgMute(true)">禁言</el-button>
							<el-button v-show="isUserTypeOne && isFriend && activeFriend.msgMuted" type="info" plain
								@click="onToggleMsgMute(false)">取消禁言</el-button>
							<el-button v-show="isUserTypeOne && !isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<el-button v-show="isUserTypeOne && isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button>
							<el-button v-show="isUserTypeOne && isFriend" type="warning" plain
								@click="onResetPassword(userInfo)">初始化密码</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
		<el-dialog title="好友备注" :visible.sync="remarkDialogVisible" width="400px" append-to-body
			:close-on-click-modal="false" @closed="remarkDraft = ''">
			<el-input v-model="remarkDraft" type="textarea" :rows="3" maxlength="32" show-word-limit
				placeholder="设置备注名，将显示在好友列表与聊天列表；留空则使用昵称" />
			<span slot="footer" class="dialog-footer">
				<el-button @click="remarkDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="onSaveRemark">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="新增分组" :visible.sync="createGroupDialogVisible" width="400px" append-to-body
			:close-on-click-modal="false" @closed="createGroupName = ''">
			<el-input v-model="createGroupName" maxlength="20" show-word-limit placeholder="请输入分组名称" />
			<span slot="footer" class="dialog-footer">
				<el-button @click="createGroupDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="onCreateGroup">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="好友分组" :visible.sync="assignGroupDialogVisible" width="420px" append-to-body
			:close-on-click-modal="false">
			<el-form label-width="90px" size="small">
				<el-form-item label="分组">
					<el-select v-model="assignGroupId" placeholder="请选择分组" style="width: 100%">
						<el-option :value="null" label="未分组"></el-option>
						<el-option v-for="g in friendGroups" :key="g.id" :value="g.id" :label="g.name"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="assignGroupDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="onAssignGroup">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="编辑分组" :visible.sync="editGroupDialogVisible" width="420px" append-to-body
			:close-on-click-modal="false">
			<el-form label-width="90px" size="small">
				<el-form-item label="分组名称">
					<el-input v-model="editGroupName" maxlength="20" show-word-limit placeholder="请输入分组名称"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="danger" plain @click="onDeleteGroup">删 除</el-button>
				<el-button @click="editGroupDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="onUpdateGroup">保 存</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			userInfo: {},
			activeFriend: {},
			lastRefreshTime: 0,
			remarkDialogVisible: false,
			remarkDraft: "",
			friendGroups: [],
			activeGroupId: null,
			createGroupDialogVisible: false,
			createGroupName: "",
			assignGroupDialogVisible: false,
			assignGroupId: null,
			editGroupDialogVisible: false,
			editGroupId: null,
			editGroupName: "",
			groupPressTimer: null
		}
	},
	mounted() {
		this.refreshFriendListIfNeeded(true);
		this.loadFriendGroups();
	},
	activated() {
		// keep-alive 切换回来时刷新，确保显示最新好友列表
		this.refreshFriendListIfNeeded(false);
		this.loadFriendGroups();
	},
	methods: {
		loadFriendGroups() {
			this.$http({
				url: "/friendGroup/list",
				method: "get"
			}).then((list) => {
				this.friendGroups = Array.isArray(list) ? list : [];
			}).catch(() => {});
		},
		refreshFriendListIfNeeded(force) {
			const now = Date.now();
			if (!force && this.lastRefreshTime && now - this.lastRefreshTime < 1500) {
				return;
			}
			this.lastRefreshTime = now;
			this.friendStore.loadFriend().catch(() => {});
		},
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.loadUserInfo(friend.id);
		},
		friendDisplayName(f) {
			if (!f || !f.id) {
				return "";
			}
			const r = f.remark != null && String(f.remark).trim();
			return r ? String(f.remark).trim() : (f.nickName || "");
		},
		onOpenRemarkDialog() {
			this.remarkDraft = this.activeFriend.remark != null ? String(this.activeFriend.remark) : "";
			this.remarkDialogVisible = true;
		},
		onOpenCreateGroupDialog() {
			this.createGroupDialogVisible = true;
		},
		onCreateGroup() {
			const name = this.createGroupName != null ? String(this.createGroupName).trim() : "";
			if (!name) {
				this.$message.warning("请输入分组名称");
				return;
			}
			this.$http({
				url: "/friendGroup/create",
				method: "post",
				data: { name }
			}).then(() => {
				this.$message.success("分组已创建");
				this.createGroupDialogVisible = false;
				this.loadFriendGroups();
			});
		},
		onOpenAssignGroupDialog() {
			this.assignGroupId = this.activeFriend.groupId != null ? this.activeFriend.groupId : null;
			this.assignGroupDialogVisible = true;
		},
		onGroupMouseDown(g) {
			this.onGroupMouseUp();
			this.groupPressTimer = setTimeout(() => {
				this.onOpenEditGroupDialog(g);
			}, 650);
		},
		onGroupMouseUp() {
			if (this.groupPressTimer) {
				clearTimeout(this.groupPressTimer);
				this.groupPressTimer = null;
			}
		},
		onOpenEditGroupDialog(g) {
			if (!g || !g.id) {
				return;
			}
			this.editGroupId = g.id;
			this.editGroupName = g.name || "";
			this.editGroupDialogVisible = true;
		},
		onUpdateGroup() {
			const name = this.editGroupName != null ? String(this.editGroupName).trim() : "";
			if (!name) {
				this.$message.warning("请输入分组名称");
				return;
			}
			this.$http({
				url: "/friendGroup/update",
				method: "put",
				data: { id: this.editGroupId, name }
			}).then(() => {
				this.$message.success("分组已更新");
				this.editGroupDialogVisible = false;
				this.loadFriendGroups();
			});
		},
		onDeleteGroup() {
			this.$confirm("确认删除该分组吗？分组内有好友时不可删除。", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$http({
					url: `/friendGroup/delete/${this.editGroupId}`,
					method: "delete"
				}).then(() => {
					this.$message.success("分组已删除");
					if (this.activeGroupId === this.editGroupId) {
						this.activeGroupId = null;
					}
					this.editGroupDialogVisible = false;
					this.loadFriendGroups();
				});
			}).catch(() => {
				// 用户取消删除
			});
		},
		onAssignGroup() {
			const fid = this.userInfo.id;
			if (!fid) {
				return;
			}
			this.$http({
				url: "/friendGroup/assign",
				method: "put",
				data: { friendId: fid, groupId: this.assignGroupId }
			}).then(() => {
				const g = this.friendGroups.find(x => x.id === this.assignGroupId);
				const next = {
					...this.activeFriend,
					groupId: this.assignGroupId,
					groupName: g ? g.name : undefined
				};
				this.activeFriend = next;
				this.friendStore.updateFriend(next);
				this.assignGroupDialogVisible = false;
				this.$message.success("分组已更新");
			});
		},
		onSaveRemark() {
			const fid = this.userInfo.id;
			if (!fid) {
				return;
			}
			const remark = this.remarkDraft != null ? String(this.remarkDraft).trim() : "";
			this.$http({
				url: "/friend/remark",
				method: "put",
				data: { friendId: fid, remark }
			}).then(() => {
				this.$message.success("备注已保存");
				const next = { ...this.activeFriend, remark: remark || undefined };
				this.activeFriend = next;
				this.friendStore.updateFriend(next);
				this.chatStore.updateChatFromFriend(next);
				this.remarkDialogVisible = false;
			});
		},
		onToggleMsgMute(muted) {
			const fid = this.userInfo.id;
			if (!fid) {
				return;
			}
			this.$http({
				url: "/friend/msgMute",
				method: "put",
				data: { friendId: fid, muted }
			}).then(() => {
				this.$message.success(muted ? "已禁言，双方无法私聊" : "已取消禁言");
				const next = { ...this.activeFriend, msgMuted: muted };
				this.activeFriend = next;
				this.friendStore.updateFriend(next);
				this.chatStore.updateChatMsgMuted(fid, muted);
			});
		},
		onDelFriend(friend) {
			const tip = this.isUserTypeOne
				? `确认删除好友「${friend.nickName}」？对方账号将被一并注销，并清空聊天记录。`
				: `确认删除'${friend.nickName}',并清空聊天记录吗?`;
			this.$confirm(tip, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success("删除好友成功");
					this.friendStore.removeFriend(friend.id);
					this.chatStore.removePrivateChat(friend.id);
				})
			})
		},
		onResetPassword(friend) {
			if (!friend || !friend.id) {
				return;
			}
			this.$confirm(`确认将「${friend.nickName}」的密码初始化为 123456 吗？`, "确认操作", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$http({
					url: "/user/resetPassword",
					method: "put",
					params: { userId: friend.id }
				}).then(() => {
					this.$message.success("密码已初始化为 123456");
				});
			});
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImageThumb,
					online: user.online
				}
				this.friendStore.addFriend(friend);
				this.refreshFriendListIfNeeded(true);
			})
		},
		onSendMessage(friend) {
			let chat = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: this.friendDisplayName(friend),
				headImage: friend.headImage,
				isDnd: friend.isDnd,
				msgMuted: friend.msgMuted === true
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			this.$router.push("/home/chat");
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$eventBus.$emit("openFullImage", this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				if (this.activeFriend.remark !== undefined) {
					friend.remark = this.activeFriend.remark;
				}
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		isUserTypeOne() {
			return this.userStore.userInfo && this.userStore.userInfo.type === 1;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friendPanelTitle() {
			if (!this.userInfo || !this.userInfo.id) {
				return "";
			}
			return this.friendDisplayName(this.activeFriend) || this.userInfo.nickName || "";
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted) {
					return;
				}
				if (this.activeGroupId !== null) {
					const gid = f.groupId != null ? f.groupId : null;
					if (gid !== this.activeGroupId) {
						return;
					}
				}
				const display = this.friendDisplayName(f);
				if (this.searchText) {
					const kw = this.searchText.trim();
					const hitNick = f.nickName && f.nickName.includes(kw);
					const hitRemark = f.remark && String(f.remark).includes(kw);
					const hitDisplay = display.includes(kw);
					if (!hitNick && !hitRemark && !hitDisplay) {
						return;
					}
				}
				let letter = this.firstLetter(display || f.nickName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = '在线'
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	}
}
</script>

<style lang="scss" scoped>
.friend-page {

	.header {
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0 8px;

		.add-btn {
			padding: 5px !important;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
		}
	}

	.group-bar {
		padding: 0 8px 8px;
		.group-scroll {
			height: 36px;
		}
		.group-items {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 4px 0;
			white-space: nowrap;
		}
		.group-item {
			padding: 4px 10px;
			border-radius: 999px;
			border: 1px solid #e6e6e6;
			background: #fff;
			color: #606266;
			font-size: 12px;
			cursor: pointer;
			user-select: none;
		}
		.group-item.active {
			border-color: var(--im-color-primary);
			color: var(--im-color-primary);
			background: var(--im-color-primary-light-9);
		}
	}

	.friend-items {
		flex: 1;

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: var(--im-text-color-light);
		}
	}
}

.container {
	display: flex;
	flex-direction: column;

	.header {
		height: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 12px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);
		box-sizing: border-box;
	}

	.friend-info {
		display: flex;
		padding: 50px 80px 20px 80px;
		text-align: center;

		.info-item {
			margin-left: 20px;
			background-color: #ffffff;
			border: 1px #ddd solid;
		}

		.description {
			padding: 20px 20px 0 20px;
		}
	}

	.btn-group {
		text-align: left !important;
		padding: 20px;
	}
}
</style>